import * as yup from 'yup';
import addValidation from './addValidation';

const createChildValidationSchema = () => (yup.object({
  children: yup.array()
    .of(
      yup.object({
        lastName: addValidation('lastName'),
        firstName: addValidation('firstName'),
        birthDate: addValidation('birthDate'),
        gender: addValidation('gender'),
        howToCall: addValidation('howToCall'),
        specialRequirements: addValidation('specialRequirements'),
        connections: yup.array()
          .of(
            yup.object({
              lastName: addValidation('lastName'),
              firstName: addValidation('firstName'),
              phoneNumber: addValidation('phoneNumber'),
            }),
          ),
      }),
    ),
}));

export default createChildValidationSchema;
